<template>
  <div class="baseSearchBox">
    <el-form :inline="true">
      <el-form-item>
        <el-select clearable v-model="searchType" filterable placeholder="请选择" value-key="value"
          @change="onChangeSelect">
          <el-option v-for="item in searchList" :key="item.value" :label="item.label" :value="item">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-if="searchType!=''">
        <el-select filterable v-model="searchParams[curSelect.paramName]" :placeholder="'请选择'+ curSelect.label"
          v-if="curSelect.inputType == 'select'&&!curSelect.remote">
          <el-option v-for="item in curSelect.optionData" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
        <el-select v-model="searchParams[curSelect.paramName]" :placeholder="'请选择'+ curSelect.label" remote filterable 
          v-if="curSelect.inputType == 'select' && curSelect.remote">
          <el-option v-for="item in curSelect.optionData" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
        <selectHospital v-if="curSelect.inputType == 'hospital'" :placeholder="'请选择'+ curSelect.label" @getChooseHospitalId="getChooseHospitalId" ref="selectHospitalId"></selectHospital>
        <el-input v-model="searchParams[curSelect.paramName]" :placeholder="'请输入'+curSelect.label"
          v-if="curSelect.inputType == 'input'" autocomplete="off"></el-input>
        <el-date-picker v-if="curSelect.inputType == 'datetimerange'" v-model="searchParams[curSelect.paramName]"
          value-format="yyyy-MM-dd" :default-time="['00:00:00']" clearable align="center" popper-class="popper-class"
          type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item v-if="tagList && tagList.length">
        <el-tag class="searchTag" size="small" v-for="(item,index) in tagList" :key='index' closable
          @close="tagClose(index)">
          <span>{{item.label}}</span>
        </el-tag>
      </el-form-item>
      <el-form-item>
        <el-button @click="onResetClick">重置</el-button>
        <el-button type="primary" @click="onSearchClick">搜索</el-button>
      </el-form-item>
      <div class="float-right" v-if="showRightBtn">
        <el-button type="primary"  @click="newFunc">{{newFuncName}}</el-button>
      </div>
      <div class="float-right" style="margin:0 20px 0 0;" v-if="showRightBtnLink">
        <el-button type="primary"  @click="newFuncLink">{{newFuncNameLink}}</el-button>
      </div>
    </el-form>
  </div>
</template>
<script>
export default {
  props: {
    //使用可参考termList.vue
    // *必填项
    searchList: {
      type: Array,
      default: [
        /* {
          label: "选择条件下拉label", // * 
          value: 1, //选择条件下拉value *
          paramName: "xx", //xx 传入后端参数名称 *
          inputType: "select", //条件类型 select input datetimerange * 根据需求继续累加
          optionData: [ // inputType为select时对应条件下拉选择项 
            {
              label: "label",
              value: "value"
            }
          ]
        },
        {
          label: "时间范围",
          value: 7,
          paramName: "timeRange", // 必须为timeRange
          inputType: "datetimerange", //时间范围
          paramstartTime: "xxx", //xxx 传入后端开始时间字段名称
          paramEndTime: "xxxx" //xxxx 传入后端结束时间字段名称
        }
         */
      ],
      require: true
    },
    newFuncName:{
      type:String,
      default:''
    },
    newFuncNameLink:{
      type:String,
      default:''
    },
    showRightBtn:{
      type:Boolean,
      default:false
    },
    showRightBtnLink:{
      type:Boolean,
      default:false
    },
  },
  data() {
    return {
      searchType: "",
      curSelect: {}, //当前选择的条件
      tagList: [], //已搜索条件
      searchParams: {} //传入字段
    };
  },
  watch:{
    searchList:{
      
      handler(val) {
        if(val.length){
          for (let index = 0; index < val.length; index++) {
            // const element = val[index];
            if (val[index].default) {
              this.curSelect = val[index];

              this.searchParams[val[index].paramName] = val[index].default
              this.onSearchClick()
            }
          }
        }
      },
      immediate: true
    },
      
    // }
  },
  created() {},
  methods: {
    getChooseHospitalId(val,name){
      for (let index = 0; index < this.searchList.length; index++) {
        if(this.searchList[index].inputType=='hospital'){
          this.searchParams[this.searchList[index].paramName] = val
          this.searchParams.hospitalName = name
        }
      }
    },
    deleteTag(key){
      this.tagList.map((item, eq) => {
        if (item.paramName == key) {
          //删除时间范围开始及结束时间值
          // if (item.paramName == "timeRange") {
          //   this.searchList.map(items => {
          //     if (items.value == item.type) {
          //       delete this.searchParams[items.paramstartTime];
          //       delete this.searchParams[items.paramEndTime];
          //     }
          //   });
          // }
          delete this.searchParams[item.paramName];
          this.tagList.splice(eq, 1);
        }
      });
      
    },
    newFunc(){
      this.$emit('newFunc')
    },
    newFuncLink(){
      this.$emit('newFuncLink')
    },
    //选择条件
    onChangeSelect(item) {
      this.curSelect = item;
    },
    //搜索
    onSearchClick() {
      if (this.curSelect != {}) {
        let obj = this.searchParams;
        if (this.curSelect.inputType == "select") {
          this.searchList.map(item => {
            if (item.paramName && item.paramName == this.curSelect.paramName) {
              item.optionData.map(itemVal => {
                if (itemVal.value == obj[item.paramName]) {
                  this.handleTag(itemVal.label);
                }
              });
            }
          });
        } else if (this.curSelect.inputType == "input") {
          this.handleTag(obj[this.curSelect.paramName]);
        }else if (this.curSelect.inputType == "hospital") {
          this.handleTag(obj.hospitalName);
        } else if (this.curSelect.inputType == "datetimerange") {
          obj[this.curSelect.paramstartTime] = obj[this.curSelect.paramName][0];
          obj[this.curSelect.paramEndTime] = obj[this.curSelect.paramName][1];
          this.handleTag(
            obj[this.curSelect.paramstartTime] +
              "~" +
              obj[this.curSelect.paramEndTime]
          );
        }
      }
      this.$emit("getSearchObj", this.searchParams);
    },
    handleTag(name) {
      if (this.tagList.length) {
        this.tagList.map((tag, eq) => {
          if (tag.type == this.searchType.value) {
            this.tagList.splice(eq, 1);
          }
        });
      }
      if (name) {
        this.tagList.push({
          label: name,
          type: this.searchType.value,
          paramName: this.curSelect.paramName
        });
      }
      if (this.curSelect.inputType == "datetimerange") {
        delete this.searchParams[this.curSelect.paramName];
      }
      this.searchType = "";
      this.curSelect = {};
    },
    tagClose(index) {
      //移除搜索条件值
      this.tagList.map((item, eq) => {
        if (index == eq) {
          //删除时间范围开始及结束时间值
          if (item.paramName == "timeRange") {
            this.searchList.map(items => {
              if (items.value == item.type) {
                delete this.searchParams[items.paramstartTime];
                delete this.searchParams[items.paramEndTime];
              }
            });
          }
          delete this.searchParams[item.paramName];
        }
      });
      //移除已选择条件
      this.tagList.splice(index, 1);
      this.$emit("getSearchObj", this.searchParams);
    },
    //重置
    onResetClick() {
      this.tagList = [];
      this.searchParams = this.$options.data().searchParams;
      this.searchType = "";
      this.$emit("getSearchObj", this.searchParams);
    }
  }
};
</script>  
<style scoped lang="less">
.baseSearchBox {
  display: inline-block;
  width: 100%;
}
.searchTag {
  border-radius: 11px;
  margin-right: 15px;
}
.float-right {
  float: right;
}
</style>